// Section 5: the trait registry. TraitId is derived from config.traits.
import type { Config } from '../../config';
import { checkRegistryKeys, type TraitDef } from '../../core/registry';
import type { TraitId } from '../../core/types';
import { charismatic } from './charismatic';
import { devout } from './devout';
import { diligent } from './diligent';
import { fertile } from './fertile';
import { frail } from './frail';
import { gentle } from './gentle';
import { hardy } from './hardy';
import { quickLearner } from './quick-learner';
import { restless } from './restless';
import { volatile } from './volatile';

/** Build the traits registry for a config (content numbers come from the config, ADR-0008). */
export function buildTraits(config: Config) {
  const traits = Object.freeze({
    hardy: hardy(config),
    frail: frail(config),
    diligent: diligent(config),
    'quick-learner': quickLearner(config),
    devout: devout(config),
    restless: restless(config),
    fertile: fertile(config),
    gentle: gentle(config),
    volatile: volatile(config),
    charismatic: charismatic(config),
  } satisfies Record<TraitId, TraitDef>);
  checkRegistryKeys('traits', traits);
  return traits;
}
